import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FormGroupType } from '../../../../../../core/models/form-group-type';
import { IncludeFrequencyForValidationEmissionDesignator } from '../../models/include-frequency-for-validation/include-frequency-for-validation-emission-designator';
import { ActionCode } from '../../../../../../core/models/resources/action-code';

@Injectable({
    providedIn: 'root',
})
export class IncludeFrequencyForValidationEmissionDesignatorFormService {
    getFormDefinition(): FormGroup<
        FormGroupType<IncludeFrequencyForValidationEmissionDesignator>
    > {
        return new FormGroup<
            FormGroupType<IncludeFrequencyForValidationEmissionDesignator>
        >({
            emissionDesignatorCode: new FormControl<string | null>(null),
            actionCode: new FormControl<ActionCode | null>(null),
        });
    }
}
